import {
  HISTORY_GET_SPORT_BETS_HISTORY,
  HISTORY_GET_SPORT_BETS_HISTORY_FAILURE,
  HISTORY_GET_SPORT_BETS_HISTORY_SUCCESS,
} from "@shared/constants";
import { serverErrorHandler } from "@shared/reducers/error";
import { checkResponse, post } from "@shared/utils/server";
import { all, call, fork, put, takeLatest } from "redux-saga/effects";

export function* getSportBetsHistory({ payload }) {
  try {
    const response = yield call(post, {
      method: "History.getSport",
      args: payload,
    });

    checkResponse(response);
    yield put({
      type: HISTORY_GET_SPORT_BETS_HISTORY_SUCCESS,
      payload: {
        response: response[0],
        status: payload.status,
      },
    });
  } catch (error) {
    yield put({
      type: HISTORY_GET_SPORT_BETS_HISTORY_FAILURE,
      payload: serverErrorHandler(error.message),
    });
  }
}

function* watchSportBetsHistory() {
  yield takeLatest(HISTORY_GET_SPORT_BETS_HISTORY, getSportBetsHistory);
}

export default function* history() {
  yield all([fork(watchSportBetsHistory)]);
}
